'use client';

import React from 'react';

import { useRouter } from 'next/navigation';

import analytics from '@repo/analytics';
import {
  authenticationStoreSelector,
  useAuthenticationStore,
} from '@repo/editor/src/stores/authenticationStore';
import {
  userStoreSelector,
  useUserStore,
} from '@repo/editor/src/stores/userStore';
import { Button } from '@repo/ui-kit/components/core/Button';

import { LANDING_PAGES_SIGN_UP_SHOW } from 'global/analyticsEvents';
import { LandingButtonProps } from 'strapi/component/landingButton/types';

export const LandingButton: React.FC<LandingButtonProps> = ({
  label,
  isSignUp,
  url,
  analyticsMeta,
}) => {
  const isLoggedIn = useUserStore(userStoreSelector.isLoggedIn);
  const router = useRouter();
  const openAuthentication = useAuthenticationStore(
    authenticationStoreSelector.openAuthentication
  );

  const handleAuthentication = async (): Promise<void> => {
    if (isLoggedIn || !isSignUp) {
      router.push(url);
    } else {
      openAuthentication({
        redirectUrl: url,
      });
      await analytics.track(LANDING_PAGES_SIGN_UP_SHOW, {
        component: analyticsMeta.componentName,
        title: analyticsMeta.title,
      });
    }
  };

  return (
    <Button
      name="authenticateLandingButton"
      variant="primary"
      width="fit-content"
      onClick={handleAuthentication}
    >
      <Button.Label>{label}</Button.Label>
    </Button>
  );
};
